const CalendarDot = ({ color }: { color: string }) => {
  return (
    <div
      className="w-4 h-4 rounded-full border border-[#0C0D0D] border-solid"
      style={{ backgroundColor: color }}
    />
  );
};

export default CalendarDot;
